// extracted by mini-css-extract-plugin
export var container = "_63-0";
export var infoButton = "_63-1";
export var label = "_63-3";
export var labelExpanded = "_63-4";
export var price = "_63-5";
export var priceExpanded = "_63-6";
export var title = "_63-2";